export const LAYER_TYPES_WITH_JUMP = ['jump', 'typeahead', 'select-one'];
export const JUMP_TO_LAYER = 'jump';
